import { DRIVER_EVENTS } from "../constants";
import appConstants from "../../../../../appConstants";
import {getHazmatPlacards} from "./HazmatPlacard/utils"

const isStopLocked = (stop, currentRouteStatus) => {
  // Lock stop if stop is completed, isLocked set to true or stop is enroute or arrived at by driver
  return stop.isLocked || isStopLockedPermanently(stop, currentRouteStatus);
};

const isStopLockedPermanently = (stop, currentRouteStatus) => {
  return (
    stop.isStopCompleted ||
    ([DRIVER_EVENTS.ArrivedAtStop, DRIVER_EVENTS.EnrouteToStop].includes(
      currentRouteStatus?.status
    ) &&
      currentRouteStatus?.stopId === stop.stopId)
  );
};

const getShipmentsInTrailer = (routeData) => {
  return routeData.stops.reduce((shipmentsInTrailer, stop) => {
    let stopShipments = [];
    if (stop.isStopCompleted) {
      if (stop.stopType === appConstants.STOP_TYPE.Delivery) {
        stopShipments = stop.shipments.filter(
          (shipment) => shipment.deliveryCode === appConstants.DELIVERY_CODE.RTN
        );
      } else {
        stopShipments = stop.shipments;
      }
    } else if (stop.stopType === appConstants.STOP_TYPE.Delivery) {
      stopShipments = stop.shipments;
    }
    return [...shipmentsInTrailer, ...stopShipments];
  }, []);
};

const getRoutePlacards = (routeData, hazmatPlacardInfo=[]) => {
  const allShipmentsInTrailer = getShipmentsInTrailer(routeData);
  return getHazmatPlacards(allShipmentsInTrailer, hazmatPlacardInfo.filter((placard) => placard.description))
}

const getProNumbers = (shipments) => {
  return shipments
    .filter((shipment) => shipment.proId  && shipment.proId !== "0")
    .map((shipment) => shipment.proId);
};

const getDriverGateInAndOutTime = (props) => {
  return { gateOutTime: props.gateOutTime ?? "", gateInTime: props.gateInTime ?? "" };
};

const getFeetInchesDisplayValue = (feet, inches) => {
  if (!feet) {
    return 'NA';
  }
  let inchesString = inches ? ` ${inches} inches` : '';
  return `${feet} feet${inchesString}`;
};

const getCombinedExcessiveLength = (feet, inches) => {
  return (feet || 0) + (inches || 0) / 100;
};

export {
  isStopLockedPermanently,
  isStopLocked,
  getRoutePlacards,
  getProNumbers,
  getDriverGateInAndOutTime,
  getFeetInchesDisplayValue,
  getCombinedExcessiveLength,
};
